import { css } from '@emotion/react'
import { mq, typography } from '@/styles'

export const styles = () => ({
  view: {
    main: css`
      max-width: 800px;
      min-height: 80px;
    `,
    content: {
      main: css`
        &:not(:last-of-type) {
          margin-bottom: 10px;
        }

        ${mq.tablet(css`
          width: 100%;
        `)}
      `,

      identifier: css`
        margin-bottom: 16px;
        font-size: ${typography.h6};
      `,

      navigation: css`
        display: flex;
        flex-wrap: wrap;

        min-height: 22px;

        & > div:not(:last-of-type) {
          margin-right: 16px;
        }
      `,
    },
  },
})
